interface SelectedState {
  nodes: Record<string, string>
  edges: Record<string, string>
  edgess?: Record<string, string>
}

interface GraphRootState {
  graph?: {
    selected?: SelectedState
  }
}

const defaultSelectedState: SelectedState = {
  nodes: {},
  edges: {},
}


const selectSelected = (state: Record<string, unknown>): SelectedState => {
  const graph = (state as GraphRootState).graph
  return graph?.selected ?? defaultSelectedState
}

export default selectSelected
